export type AWBStatus = 'DRAFT' | 'BOOKED' | 'PICKED_UP' | 'IN_TRANSIT' | 'OUT_FOR_DELIVERY' | 'DELIVERED' | 'RETURNED' | 'CANCELLED';

export type PaymentMethod = 'CASH' | 'CHEQUE' | 'ONLINE' | 'CREDIT' | 'PREPAID' | 'COD';

export type KYCType = 'PASSPORT' | 'DRIVING_LICENSE' | 'VOTER_ID' | 'AADHAAR' | 'PAN_CARD' | 'NATIONAL_ID';

export type InvoiceType = 'PROFORMA_INVOICE' | 'COMMERCIAL_INVOICE' | 'INVOICE';

export type TrackingEventType = 'MANUAL' | 'API';

export type AttachmentCategory = 'SHIPMENT_INVOICE' | 'ADDRESS_LABEL' | 'AUTHORIZATION_LETTER' | 'POD' | 'OTHER';

export const AWB_STATUS_LABELS: Record<AWBStatus, string> = {
    DRAFT: 'Draft',
    BOOKED: 'Booked',
    PICKED_UP: 'Picked Up',
    IN_TRANSIT: 'In Transit',
    OUT_FOR_DELIVERY: 'Out for Delivery',
    DELIVERED: 'Delivered',
    RETURNED: 'Returned',
    CANCELLED: 'Cancelled'
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
    CASH: 'Cash',
    CHEQUE: 'Cheque',
    ONLINE: 'Online',
    CREDIT: 'Credit',
    PREPAID: 'Prepaid',
    COD: 'Cash on Delivery'
};

export const KYC_TYPE_LABELS: Record<KYCType, string> = {
    PASSPORT: 'Passport',
    DRIVING_LICENSE: 'Driving License',
    VOTER_ID: 'Voter ID',
    AADHAAR: 'Aadhaar Card',
    PAN_CARD: 'PAN Card',
    NATIONAL_ID: 'National ID'
};

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
    PROFORMA_INVOICE: 'Proforma Invoice',
    COMMERCIAL_INVOICE: 'Commercial Invoice',
    INVOICE: 'Invoice'
};

export const AWB_STATUS_COLORS: Record<AWBStatus, string> = {
    DRAFT: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
    BOOKED: 'bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-200',
    PICKED_UP: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-200',
    IN_TRANSIT: 'bg-purple-100 text-purple-800 dark:bg-purple-800 dark:text-purple-200',
    OUT_FOR_DELIVERY: 'bg-orange-100 text-orange-800 dark:bg-orange-800 dark:text-orange-200',
    DELIVERED: 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-200',
    RETURNED: 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-200',
    CANCELLED: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200'
}; 